<template>
  <div class="token-invalid">
    <template v-if="getVerificationErrorCode">
      <div class="status-text">{{getVerificationErrorCode}} ERROR</div>
      <template v-if="getVerificationErrorCode + '' === '403'">
        <div class="status-text">Forbidden access. Contact your security dealer for more detail.</div>
      </template>
      <template v-else>
        <div class="status-text">INVALID REQUEST</div>
      </template>
    </template>
    <template v-else>
      <div class="status-text">The verification period has ended.</div>
    </template>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'token-invalid',
  components: {
    CompIcon
  },
  computed: {
    getVerificationErrorCode: function () {
      return this.$store.getters.getVerificationErrorCode
    }
  },
  data: function () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.token-invalid {
  /* common */
  background-color: #000;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.token-invalid .status-text {
  /* common */
  color: #fff;
  font-size: 16px;
  /* position */
  margin: 1em;
  /* text */
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/TokenInvalid.vue